(() => {
  function init(root = document) {
    const guide = root.matches?.('.fj-guide') ? root : root.querySelector?.('.fj-guide') || root.closest?.('.fj-guide');
    if (!guide) return;
    const chartSection = guide.querySelector('#size');
    if (chartSection && !chartSection.dataset.initialized) {
      const rows = [...chartSection.querySelectorAll('[data-guide-row]')].map(row => ({
        us: row.dataset.us, alpha: row.dataset.alpha,
        waist: Number(row.dataset.waist), hip: Number(row.dataset.hip)
      }));
      chartSection.dataset.initialized = 'true';
      let unit = 'in', chart = 'alpha';
      const format = value => unit === 'in' ? String(value) : (value * 2.54).toFixed(1);
      const range = values => {
        const min = Math.min(...values), max = Math.max(...values);
        return min === max ? format(min) : `${format(min)}–${format(max)}`;
      };
      function cell(row, value, heading = false) {
        const el = document.createElement(heading ? 'th' : 'td');
        if (heading) el.scope = 'row';
        el.textContent = value;
        row.append(el);
      }
      function render() {
        chartSection.querySelector('#waist-header').textContent = `Waist (${unit})`;
        chartSection.querySelector('#hip-header').textContent = `Hip (${unit})`;
        const extraHeader = chartSection.querySelector('#us-header');
        extraHeader.hidden = chart === 'numeric';
        extraHeader.textContent = 'US';
        const body = chartSection.querySelector('#chart-body');
        body.replaceChildren();
        const groups = chart === 'numeric' ? rows.map(row => [row]) : [...new Set(rows.map(row => row.alpha))].map(label => rows.filter(row => row.alpha === label));
        groups.forEach(group => {
          const tr = document.createElement('tr');
          cell(tr, chart === 'numeric' ? group[0].us : group[0].alpha, true);
          if (chart === 'alpha') cell(tr, group.length === 1 ? group[0].us : `${group[0].us}–${group.at(-1).us}`);
          cell(tr, range(group.map(row => row.waist)));
          cell(tr, range(group.map(row => row.hip)));
          body.append(tr);
        });
      }
      for (const key of ['unit', 'chart']) chartSection.querySelectorAll(`[data-${key}]`).forEach(button => {
        button.addEventListener('click', () => {
          if (key === 'unit') unit = button.dataset.unit; else chart = button.dataset.chart;
          chartSection.querySelectorAll(`[data-${key}]`).forEach(other => other.setAttribute('aria-pressed', String(other === button)));
          render();
        });
      });
      render();
    }
    const anatomy = guide.querySelector('#fit');
    if (anatomy && !anatomy.dataset.initialized) {
      anatomy.dataset.initialized = 'true';
      const buttons = anatomy.querySelectorAll('[data-part]');
      const show = id => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.part === id)));
        anatomy.querySelectorAll('[data-description]').forEach(label => label.classList.toggle('is-selected', label.dataset.description === id));
      };
      buttons.forEach(button => button.addEventListener('click', () => show(button.dataset.part)));
      show(anatomy.querySelector('[data-part]')?.dataset.part);
    }
    const form = guide.querySelector('.compare-form');
    if (form && !form.dataset.initialized) {
      form.dataset.initialized = 'true';
      form.addEventListener('submit', event => {
        event.preventDefault();
        const n = Number(form.querySelector('input').value), isCm = form.querySelector('select').value === 'cm';
        const inches = isCm ? n / 2.54 : n, output = form.querySelector('.compare-result');
        if (!Number.isFinite(inches) || inches < 1 || inches > 60) {
          output.textContent = 'Enter a garment inseam between 1 and 60 inches (2.5–152.4 cm).';
          return;
        }
        const difference = Math.abs(inches - 34) - Math.abs(inches - 36);
        output.textContent = Math.abs(difference) < .02
          ? 'Your measurement sits between 34″ and 36″. Compare the style, shoes and preferred hem before choosing.'
          : `${difference < 0 ? '34″' : '36″'} is closer to your measured pair. This compares length only; check the style and preferred hem before choosing.`;
      });
    }
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const part = event.target.closest?.('[data-description]')?.dataset.description;
    if (part) event.target.closest('#fit')?.querySelector(`[data-part="${part}"]`)?.click();
  });
})();
